export const isHidden = (item) =>
  item?.isHidden === true || item?.hidden === true || item?.isVisible === false;

export const visibleItems = (items = []) => items.filter((item) => !isHidden(item));
